import { Flex } from '@/components/base';
import Heading from '@/components/Typography/Heading';
import SearchQueryBuilder from '@/features/GlobalSearch/components/SearchQueryBuilder/SearchQueryBuilder';
import { HomeFeedbackTrends, OnboardingGuide } from '@/features/home';

import StarredDashboardList from './StarredDashboardList';

const WorkspaceHome = () => {
  return (
    <div className="w-full h-full overflow-auto">
      <div className="flex flex-col w-full pt-36 px-20 pb-30 gap-7 min-w-300 bg-gray-150">
        <div className="flex flex-col gap-4 items-center">
          <Heading type="hero" weight="sb" className="text-gray-950">
            Explore what’s happening
          </Heading>
        </div>
        <Flex j="center">
          <Flex style={{ width: 640, height: 60, position: 'relative' }}>
            <Flex
              style={{
                width: '100%',
                position: 'absolute',
                top: 0,
                right: 0,
                zIndex: 10,
              }}
            >
              <SearchQueryBuilder from="home" />
            </Flex>
          </Flex>
        </Flex>
      </div>
      <div className="flex justify-center">
        <div className="flex flex-col w-full pt-20 pb-12 px-20 gap-13 min-w-300 max-w-7xl">
          <OnboardingGuide />
          <StarredDashboardList />
          <HomeFeedbackTrends />
        </div>
      </div>
    </div>
  );
};

export default WorkspaceHome;
